<template>
  <section class="contact" id="contact">
    <div class="container">
      <div class="row mx-auto title fade-in">
        <div class="col-12 text-center">
          <h1>Kontakt & Anfahrt</h1>
          <p class="textbox text-center">Besuchen Sie uns - wir freuen uns auf Sie!</p></div>
      </div>
    </div>
    <div class="container">
      <div class="row mx-auto">
        <div class="col-12 col-lg-6">
          <div class="textbox text-left profile">
            <p>Ihre Behandlungszeiten werden speziell für Sie reserviert. Daher bitte ich Sie, mindestens 48 Stunden
              vorher abzusagen, falls Sie Termine nicht wahrnehmen können. Kurzfristig abgesagte Termine werden in
              Rechnung gestellt.</p>
            <p class="location"><a
                href="https://www.google.com/maps/place/Haarlem+Friseure/@53.5716198,10.0675617,17z/data=!3m1!4b1!4m5!3m4!1s0x47b18c003052ed07:0x78fc0ed1a836b525!8m2!3d53.5716166!4d10.0697504"
                target="_blank">Schloßstr. 44, 22041 Hamburg</a></p>
            <p class="mail"><a href="mailto:barbara.knoefel@t-online.de">barbara.knoefel@t-online.de</a></p>
            <p class="telephone"><a href="tel:+4917645905491">+49 176 45 90 54 91</a></p>
            <div class="opening-time">&nbsp;Öffnungszeiten:
              <div class="daily-times"><p>Dienstag - Mittwoch: 10:00 - 19:00 Uhr<br>
                Donnerstag: 10:00 - 13:00 Uhr<br>
                Freitag: 10:00 - 19:00 Uhr<br>
                Samstag: 09:00 - 13:00 Uhr</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 offset-lg-2 order-first order-lg-last image">
          <img src="../../../assets/images/barbara_knoefel.jpg" alt="Portrait von Barbara Knöfel">
        </div>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: "Contact"
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';


h1 {
  text-transform: uppercase;
  letter-spacing: 4px;
}

.title {
  margin-bottom: 35px;
}

.profile:before {
  content: '';
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 6px 5px 10px 0;
  height: 45px;
  width: 45px;
  background-image: url("../../../assets/images/profile.svg");
}

.textbox {

  &.text-left {
    position: relative;
    top: 50%;
    transform: translate(0, -50%);
  }

  .location:before, .mail:before, .telephone:before, .opening-time:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 5px;
    height: 25px;
    width: 25px;
  }

  .location:before {
    background-image: url("../../../assets/images/location_black.svg");
  }

  .mail:before {
    margin-top: 5px;
    background-image: url("../../../assets/images/mail.svg");
  }

  .telephone:before {
    background-image: url("../../../assets/images/phone.svg");
  }

  .opening-time:before {
    background-image: url("../../../assets/images/clock_black.svg");
  }

  .daily-times {
    position: relative;
    left: 34px;
  }
}

.image {
  @include media-breakpoint-down(md) {
    margin-bottom: 40px;
  }

  img {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 8px solid $black;
    border-radius: 10px;

    @include media-breakpoint-down(md) {
      max-width: 40%;
    }
  }
}
</style>
